// extracted by mini-css-extract-plugin
export default {"productCarousel":"wZ-z"};